/** What a `table` request can ask for. `write` grants everything `read` does. */
export const DynamoDbAiLevels = ["read", "write"] as const;
export type DynamoDbAiLevel = (typeof DynamoDbAiLevels)[number];

const READ_ACTIONS = [
  "dynamodb:GetItem",
  "dynamodb:BatchGetItem",
  "dynamodb:Query",
  "dynamodb:Scan",
  "dynamodb:PartiQLSelect",
  "dynamodb:DescribeTable",
  "dynamodb:DescribeTimeToLive",
] as const;

// `ConditionCheckItem` has no tool yet; `TransactWriteItems` needs it.
const WRITE_ACTIONS = [
  "dynamodb:PutItem",
  "dynamodb:UpdateItem",
  "dynamodb:DeleteItem",
  "dynamodb:BatchWriteItem",
  "dynamodb:ConditionCheckItem",
  "dynamodb:PartiQLInsert",
  "dynamodb:PartiQLUpdate",
  "dynamodb:PartiQLDelete",
] as const;

const LEVEL_ACTIONS = {
  read: READ_ACTIONS,
  write: [...READ_ACTIONS, ...WRITE_ACTIONS],
} as const satisfies Record<DynamoDbAiLevel, readonly string[]>;

/** The IAM actions `level` grants on a table and its indexes. */
export const actionsFor = (level: DynamoDbAiLevel): readonly string[] =>
  LEVEL_ACTIONS[level];
